import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import PropTypes from "prop-types";
import "./studentLop.css";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector("div");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.style.background = "#fff";
    tooltipEl.style.borderRadius = "4px";
    tooltipEl.style.padding = "4px 10px";
    tooltipEl.style.border = "0.5px solid var(--Grey-50, #AFAFAF)";
    tooltipEl.style.color = "black";
    tooltipEl.style.opacity = 1;
    tooltipEl.style.zIndex = 100000;
    tooltipEl.style.fontSize = "14px";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.transform = "translate(-50%, 0)";
    tooltipEl.style.transition = "all .1s ease";

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const externalTooltipHandler = (context) => {
  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map((b) => b.lines);

    const tableHead = document.createElement("thead");

    titleLines.forEach((title) => {
      const tr = document.createElement("tr");
      tr.style.borderWidth = 0;

      const th = document.createElement("th");
      th.style.borderWidth = 0;
      const text = document.createTextNode(title.replace("_", "'"));

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
    });
    const tableBody = document.createElement("tbody");
    bodyLines.forEach((body, i) => {
      const colors = tooltip.labelColors[i];
      const span = document.createElement("span");
      span.style.background = colors.backgroundColor;
      span.style.borderColor = colors.borderColor;
      span.style.borderWidth = "2px";
      span.style.borderRadius = "40px";
      span.style.marginRight = "10px";
      span.style.height = "10px";
      span.style.width = "10px";
      span.style.display = "inline-block";

      const tr = document.createElement("tr");
      tr.style.backgroundColor = "inherit";
      tr.style.borderWidth = 0;
      tr.style.width = "fit-content";

      const td = document.createElement("td");
      td.style.borderWidth = 0;
      td.style.width = "fit-content";
      const text = document.createTextNode(`${body + "%"}`);
      //   td.appendChild(span);
      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector("table");

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + "px";
  tooltipEl.style.top = positionY + tooltip.caretY + "px";
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
export const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        id: "x-axis-0",
        gridLines: {
          color: "gray",
          zeroLineColor: "gray",
        },
      },
    ],
    x: {
      display: false,
      grid: {
        display: false,
        color: "rgba(255, 0, 0, 0.3)",
      },
      ticks: {
        display: false,
      },
    },
    y: {
      display: false,
      suggestedMax: 100,
      suggestedMin: 0,
      grid: {
        display: false,
        color: "rgba(255, 0, 0, 0.3)",
        borderDash: [0.5, 0.5], // Sets the y-axis grid lines to be dotted
      },
      ticks: {
        display: false,
      },
    },
  },
  // borderWidth: {
  //   top: 0,
  //   left: 10,
  //   right: 10,
  //   bottom: 0,
  // },
  borderRadius: {
    topLeft: 8,
    topRight: 8,
    bottomLeft: 8,
    bottomRight: 8,
  },
  borderColor: "gray",
  plugins: {
    legend: {
      display: false, // This hides all text in the legend and also the labels.
    },
    datalabels: {
      align: "top",
      anchor: "end",
      display: false,
      formatter: function (value) {
        return value != undefined ? value : null;
      },
    },
    tooltip: {
      enabled: false,
      position: "nearest",
      external: externalTooltipHandler,
    },
  },
  title: {
    display: false,
    text: "Student LOP",
  },
};

function LineGraph(props) {
  const { linedata, barArray, mode } = props;
  const graphData =
    mode == "attendance"
      ? Object.values(barArray)
      : linedata.map((item) => item.risk);
  const graphLabel = mode == "attendance" ? Object.keys(barArray) : barArray;
  const linelabel1 = mode == "attendance" ? "Attendend" : "Risk";
  const data = {
    labels: graphLabel,
    datasets: [
      {
        label: linelabel1,
        data: graphData,
        borderColor: "#00b0f5",
        backgroundColor: "#ffffff",
        borderWidth: "3",
      },
      {
        label: "Class avg",
        data: linedata.map((item) => item.classAverage),
        borderColor: "lightgray",
        backgroundColor: "#ffffff",
        borderWidth: "3",
      },
    ],
  };
  return (
    <div className="d-flex linegraphcontainer">
      <Line options={options} data={data} />
    </div>
  );
}
LineGraph.propTypes = {
  linedata: PropTypes.any,
  barLabel: PropTypes.array,
  barArray: PropTypes.array,
  mode: PropTypes.string,
};
export default LineGraph;
